import * as React from 'react';
import {IconGenerator, IconProps} from './IconGenerator';

export const AngleLeftIcon = (props: IconProps) => (
  <IconGenerator viewBox='0 0 7 10' body={<path d='M6 9L2 5L6 1' stroke={props.color} strokeWidth='2' />} {...props} color='transparent' />
);
